export const en = {
    'cloud-name': 'Yandex.Cloud LLC',
    'label-item-privacy': 'Privacy policy',
    'label-item-terms': 'Terms of use',
    'login-button-label': 'Log in to Wiki'
};
